import DOMPurify from 'dompurify';

// Staff-authored HTML (program descriptions, policies, schedule notes) is
// rendered with dangerouslySetInnerHTML, so strip scripts, event handlers and
// javascript: URLs before it reaches the page.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export const sanitizeHtml = (html?: string | null): string =>
  html ? DOMPurify.sanitize(html, { ADD_ATTR: ['target'] }) : '';
